import { UNIT } from '../../constants/theme';

export const styles = () => ({
  subtitle: { fontWeight: 'bold' },
  designText: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bold',
    paddingBottom: '5px'
  },

  paper: { marginTop: UNIT * 0.625, padding: '0px 0px 10px 5px', width: '100%' },

  inputStyle: {
    width: '100%',
    marginTop: UNIT * 0.625
  },
  disabledStyle: {
    pointerEvents: 'none',
    opacity: 0.7
  }
});
